"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SceneSurface = void 0;
var renderer_text_layout_1 = require("@moonpig/renderer-text-layout");
var equality_1 = __importDefault(require("@wry/equality"));
var react_1 = __importStar(require("react"));
var renderer_provider_1 = require("../renderer-provider/renderer-provider");
var SceneSurface = function (_a) {
    var data = _a.data, _b = _a.size, size = _b === void 0 ? data.scene : _b, textOnly = _a.textOnly, debugOverlay = _a.debugOverlay, _c = _a.backgroundColor, backgroundColor = _c === void 0 ? 'white' : _c, hideObject = _a.hideObject;
    var textLayoutCache = (0, react_1.useRef)({});
    var textLayoutsByIdRef = (0, react_1.useRef)({});
    var _d = (0, renderer_provider_1.useRendererContext)(), renderSceneSurface = _d.renderSceneSurface, measureTextWidth = _d.measureTextWidth, resourceContext = _d.resourceContext;
    var textLayoutsById = (0, react_1.useMemo)(function () {
        data.scene.objects.forEach(function (object) {
            if (object.type === 'TEXT') {
                var key = {
                    text: object.text,
                    width: object.frame.width,
                    height: object.frame.height,
                    lineSpacing: object.lineSpacing,
                    maxFontSize: object.maxFontSize,
                    horizontalAlignment: object.horizontalAlignment,
                    verticalAlignment: object.verticalAlignment,
                    renderMethod: object.renderMethod,
                    fontUrl: object.fontUrl,
                };
                var cached = textLayoutCache.current[object.id];
                if (cached && (0, equality_1.default)(cached.key, key)) {
                    textLayoutsByIdRef.current[object.id] = cached.textLayout;
                }
                else {
                    var fontData_1 = resourceContext.getFont(object.fontUrl);
                    var textLayout = (0, renderer_text_layout_1.layoutTextBox)(__assign(__assign({}, key), { fontMetrics: fontData_1.fontMetrics, measureTextWidth: function (_a) {
                            var text = _a.text, fontSize = _a.fontSize;
                            return measureTextWidth({
                                text: text,
                                fontSize: fontSize,
                                fontData: fontData_1,
                            });
                        } }));
                    textLayoutCache.current[object.id] = { key: key, textLayout: textLayout };
                    textLayoutsByIdRef.current[object.id] = textLayout;
                }
            }
        });
        return textLayoutsByIdRef.current;
    }, [data.scene, resourceContext, measureTextWidth]);
    var surface = renderSceneSurface({
        data: data,
        size: size,
        textLayoutsById: textLayoutsById,
        backgroundColor: backgroundColor,
        textOnly: textOnly,
        debugOverlay: debugOverlay,
        hideObject: hideObject,
    });
    return react_1.default.createElement(react_1.default.Fragment, null, surface);
};
exports.SceneSurface = SceneSurface;
